import { getData, onReady } from "#Utils/dom"

function updateVatNumberVisibility() {
  const billingCountryElement = document.querySelector(".js-billing-country")
  const billingVatNumberElement = document.querySelector(".js-billing-vat-number")

  if (!billingCountryElement || !billingVatNumberElement) return

  const euCountries = getData(billingCountryElement, "eu-countries")
  const selectedCountry = billingCountryElement.value

  if (euCountries && euCountries.includes(selectedCountry)) {
    billingVatNumberElement.style.display = "flex"
  } else {
    billingVatNumberElement.style.display = "none"
  }
}

onReady(() => {
  const billingCountryElement = document.querySelector(".js-billing-country")
  if (billingCountryElement) {
    updateVatNumberVisibility()

    billingCountryElement.addEventListener("change", () => {
      updateVatNumberVisibility()
    })
  }
})
